import { RouteInitialize } from './createRoute';

const getPath = (RouteInstance: RouteInitialize, lang: string) => {
  if (RouteInstance.path) {
    return `/${lang}/${RouteInstance.path}`;
  } else {
    return `/${lang}`;
  }
};

export default getPath;
